import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/CI/B.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/CI/E.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/CI/P.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/Icon/Btb.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/Icon/Enigma_AppIcon.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/Icon/Mail.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/Icon/Rocket.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/Icon/SpinOutCats_AppIcon.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/Component/Page/PrivacyPolicyPage.jsx");
